import './AddEvent.css';
import addIcon from './../../images/add.svg';
const AddEvent = ({ setCurrentPage }) => {
    const handleAddEventClick = () => {
        setCurrentPage('AddEventPage');
    };

    return (
        <div className='add__event' onClick={handleAddEventClick}>
            <img src={addIcon} />
        </div>
    );
};

export default AddEvent;
